import { useMemo, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import {
  getSchoolState,
  updateTeacherClass,
  classLabelFromKey,
} from "@/lib/eisStore";
import {
  isSupabaseConfigured,
  updateTeacherClassInSupabase,
} from "@/lib/supabaseOps";

export default function TeacherClassPicker({ teacher, onChange }) {
  const school = getSchoolState();
  const classes = useMemo(() => school.classes || [], [school.classes]);
  const [value, setValue] = useState(teacher?.assignedClassKey || "");

  const save = async () => {
    if (!teacher?.email) {
      toast.error("Teacher profile is missing");
      return;
    }
    if (!value) {
      toast.error("Please select a class");
      return;
    }
    try {
      if (isSupabaseConfigured && teacher?.supabaseUserId) {
        await updateTeacherClassInSupabase(teacher.supabaseUserId, value);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Could not save class to the database");
      return;
    }
    updateTeacherClass(teacher.email, value);
    toast.success(`Class set to ${classLabelFromKey(value)}`);
    onChange?.(value);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ color: "#0b1f7a" }}>My Class</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Select the class you manage</Label>
          <Select
            value={value}
            onValueChange={(nextValue) => {
              setValue(nextValue);
              onChange?.(nextValue);
            }}
          >
            <SelectTrigger className="mt-1">
              <SelectValue placeholder="Choose a class" />
            </SelectTrigger>
            <SelectContent>
              {classes.map((item) => (
                <SelectItem key={item.key} value={item.key}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <Button
          type="button"
          onClick={save}
          className="rounded-full text-white"
          style={{ backgroundColor: "#0b1f7a" }}
        >
          Save Class
        </Button>
      </CardContent>
    </Card>
  );
}
